/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Footer_Powered_ByInputs */

const en_footer_powered_by = /** @type {(inputs: Footer_Powered_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Runs on ${i?.name}`)
};

const pl_footer_powered_by = /** @type {(inputs: Footer_Powered_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Działa na ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Runs on {name}" |
*
* @param {Footer_Powered_ByInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const footer_powered_by = /** @type {((inputs: Footer_Powered_ByInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Powered_ByInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_footer_powered_by(inputs)
	return en_footer_powered_by(inputs)
});